import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { ArrowLeft } from 'lucide-react'
import { ButtonLink } from '@/components/generals/button-link'
import { Tilt } from '@/components/generals/tilt'
import { SectionHeading } from '@/components/generals/section-heading'
import { PROCESS_STEPS } from '@/constants/content'

export const ProcessSection: FC = (): ReactNode => {
    return (
        <section id='process' aria-labelledby='process-title' className='py-24 lg:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='process-title'
                    align='center'
                    eyebrow='از کوه تا جهان'
                    title='چهار مرحله، از رویشگاه تا مقصد'
                    description='هر گیاه پیش از رسیدن به دست شما از چهار مرحله می‌گذرد. هیچ محموله‌ای بدون تأیید آزمایشگاه بسته‌بندی و ارسال نمی‌شود.'
                />

                <ol className='mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-7'>
                    {PROCESS_STEPS.map(({ id, number, icon: Icon, title, summary, image }) => (
                        <li key={id} className='reveal relative'>
                            <Tilt className='rounded-[1.75rem]'>
                                <div className='relative aspect-[4/3] overflow-hidden rounded-[1.75rem] border border-sand bg-forest-900'>
                                    <Image
                                        src={image.src}
                                        alt={image.alt}
                                        fill
                                        sizes='(min-width: 1024px) 22vw, (min-width: 640px) 45vw, 92vw'
                                        className={`object-cover ${image.className}`}
                                    />

                                    <div aria-hidden='true' className='absolute inset-0 bg-linear-to-t from-forest-950/50 to-transparent' />
                                </div>
                            </Tilt>

                            <div className='relative -mt-7 flex items-end justify-between px-5'>
                                <span className='flex size-14 items-center justify-center rounded-2xl border-4 border-background bg-forest-700 text-gold shadow-lg'>
                                    <Icon aria-hidden='true' className='size-6' strokeWidth={1.6} />
                                </span>

                                <span aria-hidden='true' className='font-heading text-5xl font-bold leading-none text-gold/35'>
                                    {number}
                                </span>
                            </div>

                            <h3 className='mt-4 px-1 text-2xl font-bold text-forest-900'>
                                <span className='sr-only'>مرحله {number}: </span>
                                {title}
                            </h3>

                            <p className='mt-2 px-1 text-sm leading-7 text-muted-foreground'>
                                {summary}
                            </p>
                        </li>
                    ))}
                </ol>

                <div className='mt-14 flex justify-center'>
                    <ButtonLink href='/process' variant='outline'>
                        جزئیات کامل فرایند
                        <ArrowLeft aria-hidden='true' />
                    </ButtonLink>
                </div>
            </div>
        </section>
    )
}
